import React from 'react'
import { Logo } from '@scentregroup/ui'
import style from './index.module.scss'

const UnifiedHeader = () => (
  <header role="banner" className={style.UnifiedHeader}>
    <Logo />
  </header>
)

export default UnifiedHeader
